import { useState } from "react";
import { Phone, MessageCircle, Calendar, Mail, X, ChevronUp } from "lucide-react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

interface FloatingContactWidgetProps {
  cityName?: string;
}

const FloatingContactWidget = ({ cityName }: FloatingContactWidgetProps) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const whatsappMessage = cityName 
    ? `Hallo, ich interessiere mich für eine Cyberversicherung in ${cityName}.`
    : "Hallo, ich interessiere mich für eine Cyberversicherung.";

  const contactOptions = [
    {
      icon: Phone,
      label: "Anrufen",
      href: "tel:+4917670790268",
      color: "hsl(var(--accent))",
    },
    {
      icon: MessageCircle,
      label: "WhatsApp",
      href: `https://wa.me/4917670790268?text=${encodeURIComponent(whatsappMessage)}`,
      color: "#25D366",
      external: true,
    },
    {
      icon: Calendar,
      label: "Termin",
      href: "/termin-buchen",
      color: "hsl(var(--primary))",
    },
    {
      icon: Mail,
      label: "E-Mail",
      href: "mailto:info@praxis-versichert.de",
      color: "hsl(var(--accent))",
    },
  ];

  return (
    <div className="fixed bottom-24 sm:bottom-6 right-4 sm:right-6 z-40 hidden lg:block">
      <div className="flex flex-col items-end gap-3">
        {isExpanded && (
          <div className="flex flex-col gap-2 animate-scale-in">
            {contactOptions.map((option, index) => {
              const Icon = option.icon;
              const Component = option.external ? "a" : option.href.startsWith("/") ? Link : "a";
              
              return (
                <Component
                  key={index}
                  to={option.href.startsWith("/") ? option.href : undefined}
                  href={!option.href.startsWith("/") ? option.href : undefined}
                  target={option.external ? "_blank" : undefined}
                  rel={option.external ? "noopener noreferrer" : undefined}
                  className="flex items-center gap-3 px-4 py-3 bg-card/95 backdrop-blur-sm border border-border rounded-full shadow-lg hover:shadow-xl transition-all hover:scale-105 group"
                  style={{ borderColor: option.color }}
                >
                  <Icon 
                    className="w-5 h-5 group-hover:scale-110 transition-transform" 
                    style={{ color: option.color }}
                  />
                  <span className="text-sm font-medium text-foreground whitespace-nowrap">
                    {option.label}
                  </span>
                </Component>
              );
            })}
          </div>
        )}
        
        <Button
          onClick={() => setIsExpanded(!isExpanded)}
          size="lg"
          className="rounded-full w-14 h-14 p-0 shadow-lg hover:shadow-xl transition-all bg-accent hover:bg-accent/90"
          aria-label={isExpanded ? "Kontaktoptionen schließen" : "Kontaktoptionen öffnen"}
        >
          {isExpanded ? (
            <X className="w-6 h-6" />
          ) : (
            <ChevronUp className="w-6 h-6" />
          )}
        </Button>
      </div>
    </div>
  );
};

export default FloatingContactWidget;
